const PREFIX = 'TABLE_';

/**
 * @name UPDATE_WIDTH
 * @const
 * @description Updates the width of the table
 */
export const UPDATE_WIDTH = PREFIX + 'UPDATE_WIDTH';